import React, { useEffect, useState } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import _ from "underscore";
import { useDispatch, useSelector } from "react-redux";
import {
    fetchNotificationRequest,
    readAllNotificationRequest,
    readNotificationRequest,
} from "../../store/notification/notification.actions";
import { getNotificationList } from "../../store/notification/notification.selector";
import { fetchLiveStreamByIdRequest } from "../../store/social/social.actions";
import {
    fetchOtherUserProfileRequest,
    fetchUserProfileRequest,
} from "../../store/user/user.actions";
import {
    getImage,
    getSearchedUsers,
    getUserProfile,
} from "../../store/user/user.selector";
import VIPCircleAPI from "../../store/user/vipcircle/vipcircle.api";
import { getOrderByIDRequest } from "../../store/shopping/shopping.actions";
import moment from "moment";
import { IsNullOrEmpty } from "../../helpers/utility";

const Notification = () => {
    return (
        <div className="h-full overflow-hidden md:hidden">
            <NotificationComponent />
        </div>
    );
};

export const NotificationComponent = ({ onClose }) => {
    const [type, setType] = useState("");
    const history = useNavigate();
    const dispatch = useDispatch();
    const { allNotifications, userProfile, users } = useSelector((state) => {
        return {
            allNotifications: getNotificationList(state),
            userProfile: getUserProfile(state),
            users: getSearchedUsers(state),
        };
    });

    useEffect(() => {
        dispatch(fetchNotificationRequest());
    }, []);

    let notifications = _.sortBy(allNotifications.data, "isRead");
    notifications = _.sortBy(notifications, (x) => {
        return new Date(x.dateCreated);
    }).reverse();

    let notRead = notifications.filter((x) => !x.isRead);

    let desc = <p></p>;

    const handleClick = (item) => {
        dispatch(
            readNotificationRequest({
                id: item._id,
            })
        );

        switch (item.type) {
            case "chatRoom":
                history("/page/chat", {
                    state: {
                        userId: item.content.data._id,
                    },
                });
                break;
            case "vipCircle":
                // if (item.content.data.status === "Approved") {
                //   history("/page/vip_subscription_payment", {
                //     VIPCircle: item.content.data
                //   });
                // }
                // else {
                //   history("/page/private-lounge-setting#vip")
                // }
                break;
            case "livestreamInvite":
                if (item.content.data.livestream.id) {
                    dispatch(
                        fetchLiveStreamByIdRequest({
                            id: item.content.data.livestream.id,
                            history: history,
                        })
                    );
                }
                break;
            case "schedule":
                if (
                    item.content.data.livestream._id ||
                    item.content.data.livestream.id
                ) {
                    dispatch(
                        fetchLiveStreamByIdRequest({
                            id:
                                item.content.data.livestream._id ||
                                item.content.data.livestream.id,
                            history: history,
                        })
                    );
                }
                break;
            case "followUser":
            case "subscribeUser":
                dispatch(
                    fetchOtherUserProfileRequest(
                        item.content.data.user.id,
                        history
                    )
                );
                break;
            case "orderConfirm":
            case "orderShipped":
            case "orderRejected":
            case "orderReceived":
                dispatch(getOrderByIDRequest(item.content.data.order.id));
                history("/page/order");
                break;
            case "system":
                break;
            case "accountUpgrade":
                break;
            case "referFriend":
                break;
            default:
                break;
        }
    };

    notifications = notifications.filter(
        (x) => x.type !== "chatRoom" && x.type !== "inbox"
    );
    if (!IsNullOrEmpty(type)) {
        if (type === "live") {
            notifications = notifications.filter(
                (x) =>
                    x.type === "livestreamInvite" ||
                    x.type === "vipCircle" ||
                    "schedule"
            );
        }
        if (type === "product") {
            notifications = notifications.filter(
                (x) => x.type.indexOf("order") > -1
            );
        }
    }

    return (
        <div className="p-2 md:p-0 w-full z-[70] top-0 right-0 bottom-0 h-full overflow-hidden flex flex-col">
            <div className="">
                <div className=" p-4 pb-0 md:pb-4 bg-white rounded-lg border-black-10 border-b-0 border flex justify-between">
                    <ul className="flex items-center space-x-10 pb-[7px] border-b border-black-10">
                        <li>
                            <NavLink
                                to="#"
                                onClick={() => setType("")}
                                className={`text-sm font-medium text-black-60 hover:text-orange-color pb-[7px] hover:border-b-2 border-orange-color capitalize ${
                                    type === "" ? "marketplace-nav" : ""
                                }`}
                            >
                                All
                            </NavLink>
                        </li>
                        <li>
                            <NavLink
                                to="#"
                                onClick={() => setType("live")}
                                className={`text-sm font-medium text-black-60 hover:text-orange-color pb-[7px] hover:border-b-2 border-orange-color capitalize  ${
                                    type === "live" ? "marketplace-nav" : ""
                                }`}
                            >
                                live
                            </NavLink>
                        </li>
                        <li>
                            <NavLink
                                to="#"
                                onClick={() => setType("product")}
                                className={`text-sm font-medium text-black-60 hover:text-orange-color pb-[7px] hover:border-b-2 border-orange-color capitalize  ${
                                    type === "product" ? "marketplace-nav" : ""
                                }`}
                            >
                                product
                            </NavLink>
                        </li>
                    </ul>
                    <div className="">
                        <div className="flex items-center">
                            {notifications.filter((z) => !z.isRead).length >
                                0 && <ReadMoreBtn />}

                            <span
                                onClick={onClose}
                                className="ml-3 cursor-pointer hidden md:block"
                            >
                                <svg
                                    width="22"
                                    height="22"
                                    viewBox="0 0 12 12"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <path
                                        d="M1 11L11 1M1 1L11 11"
                                        stroke="black"
                                        strokeOpacity="0.5"
                                        strokeWidth="1.26316"
                                        strokeLinecap="round"
                                        stroke-linejoin="round"
                                    />
                                </svg>
                            </span>
                        </div>
                    </div>
                </div>
            </div>
            <div className="overflow-y-auto flex-1 bg-white pt-4 rounded-bl-lg rounded-br-lg border border-black-10 border-t-0">
                {/* <Outlet /> */}
                <div>
                    {notifications.map((item) => {
                        let notify = {};
                        switch (item.type) {
                            case "chatRoom":
                                desc = <p></p>;
                                break;
                            case "livestreamInvite":
                                let isGuest =
                                    item.content.data.livestream.guests &&
                                    item.content.data.livestream.guests.indexOf(
                                        userProfile._id
                                    ) > -1;
                                if (item.content.data.status === "startLive") {
                                    notify.name =
                                        item.content.data.livestream.ownerName;
                                    notify.title =
                                        item.content.data.livestream.title;
                                    notify.notify = `has started ${item.content.data.livestream.category} livestream`;
                                    notify.action = item.isRead
                                        ? "Watch Again"
                                        : "Join now";
                                } else {
                                    if (isGuest) {
                                        notify.name =
                                            item.content.data.livestream.ownerName;
                                        notify.title =
                                            item.content.data.livestream.title;
                                        notify.notify = `invite you as co-host for ${item.content.data.livestream.category} livestream`;
                                        notify.action = item.isRead
                                            ? "Watch Again"
                                            : "Accept";
                                    } else if (
                                        item.content.data.livestream
                                            .category === "VIP Circle"
                                    ) {
                                        notify.name =
                                            item.content.data.livestream.ownerName;
                                        notify.title =
                                            item.content.data.livestream.title;
                                        notify.notify = `invite you for ${item.content.data.livestream.category} live session`;
                                        notify.action = item.isRead
                                            ? "Watch Again"
                                            : "Accept";
                                    }
                                }

                                break;
                            case "vipCircle":
                                if (
                                    item.content.data.status ===
                                    "Request to join"
                                ) {
                                    notify.name = item.content.data.guest.name;
                                    notify.title = "";
                                    notify.notify = `has requested to join ${item.content.data.title} VIP circle`;
                                    notify.action = (
                                        <span className="float-right">
                                            {!item.isRead && (
                                                <button
                                                    color="secondary"
                                                    onClick={(e) => {
                                                        e.stopPropagation();
                                                        e.preventDefault();
                                                        VIPCircleAPI.UpdateStatus(
                                                            {
                                                                userId: item
                                                                    .content
                                                                    .data.guest
                                                                    .userId,
                                                                vip: item
                                                                    .content
                                                                    .data._id,
                                                                status: "Rejected",
                                                            }
                                                        ).then((x) => {
                                                            dispatch(
                                                                readNotificationRequest(
                                                                    {
                                                                        id: item._id,
                                                                    }
                                                                )
                                                            );
                                                        });
                                                    }}
                                                    variant="contained"
                                                >
                                                    Reject
                                                </button>
                                            )}
                                            &nbsp;&nbsp;
                                            {!item.isRead && (
                                                <button
                                                    onClick={(e) => {
                                                        e.stopPropagation();
                                                        e.preventDefault();
                                                        VIPCircleAPI.UpdateStatus(
                                                            {
                                                                userId: item
                                                                    .content
                                                                    .data.guest
                                                                    .userId,
                                                                vip: item
                                                                    .content
                                                                    .data._id,
                                                                status: "Approved",
                                                            }
                                                        ).then((x) => {
                                                            dispatch(
                                                                readNotificationRequest(
                                                                    {
                                                                        id: item._id,
                                                                    }
                                                                )
                                                            );
                                                        });
                                                    }}
                                                    color="primary"
                                                    variant="contained"
                                                >
                                                    Accept
                                                </button>
                                            )}
                                        </span>
                                    );
                                } else if (
                                    item.content.data.status ===
                                    "Cancel Request"
                                ) {
                                    notify.name = item.content.data.guest.name;
                                    notify.title = "";
                                    notify.notify = `has cancelled the request to join ${item.content.data.title} VIP circle.`;
                                    notify.action = "";
                                } else if (
                                    item.content.data.status === "Approved"
                                ) {
                                    notify.name =
                                        item.content.data.owner &&
                                        item.content.data.owner.fullName;
                                    notify.title = item.content.data.title;
                                    notify.notify = `has approved your request to join ${item.content.data.title} VIP circle.`;
                                    notify.action = !item.isRead && (
                                        <button
                                            color="primary"
                                            onClick={(e) => {
                                                e.preventDefault();
                                                e.stopPropagation();
                                                VIPCircleAPI.GetVIPCircle(
                                                    item.content.data._id
                                                ).then((x) => {
                                                    history(
                                                        "/page/vip-subscription-payment",
                                                        {
                                                            VIPCircle: x.data,
                                                        }
                                                    );
                                                    dispatch(
                                                        readNotificationRequest(
                                                            {
                                                                id: item._id,
                                                            }
                                                        )
                                                    );
                                                });
                                            }}
                                            className="float-right"
                                            variant="outlined"
                                        >
                                            Subscribe Now
                                        </button>
                                    );
                                } else if (
                                    item.content.data.status === "Rejected"
                                ) {
                                    notify.name =
                                        item.content.data.owner &&
                                        item.content.data.owner.fullName;
                                    notify.title = item.content.data.title;
                                    notify.notify = `has rejected the request to join ${item.content.data.title} VIP circle.`;
                                    notify.action = "";
                                }
                                break;
                            case "schedule":
                                notify.name =
                                    item.content.data.livestream.ownerName;
                                notify.title =
                                    item.content.data.livestream.scheduleTime;
                                notify.notify = `has scheduled the ${item.content.data.livestream.category} livestream`;
                                notify.action = "";
                                break;
                            case "followUser":
                                notify.name = item.content.data.fullName;
                                notify.title = "";
                                notify.notify = `has started following you`;
                                notify.action = "";
                                break;
                            case "subscribeUser":
                                if (item.content.data.type === "VIP") {
                                    notify.name = item.content.data.fullName;
                                    notify.title = "";
                                    notify.notify = `subscribed to your VIP Circle`;
                                    notify.action = "";
                                } else {
                                    notify.name = item.content.data.fullName;
                                    notify.title = "";
                                    notify.notify = `subscribed to your private hall`;
                                    notify.action = "";
                                }
                                break;
                            case "orderConfirm":
                                notify.name = item.content.data.fullName;
                                notify.title = item.content.data.order.code;
                                notify.notify = `purchased an order`;
                                notify.action = "";
                                break;
                            case "orderShipped":
                                notify.name = item.content.data.fullName;
                                notify.title = item.content.data.order.code;
                                notify.notify = `shipped an order`;
                                notify.action = "";
                                break;
                            case "orderRejected":
                                notify.name = item.content.data.fullName;
                                notify.title = item.content.data.order.code;
                                notify.notify = `rejected an order`;
                                notify.action = "";
                                break;
                            case "orderReceived":
                                notify.name = item.content.data.fullName;
                                notify.title = item.content.data.order.code;
                                notify.notify = `received an order`;
                                notify.action = "";
                                break;
                            case "system":
                                desc = <p></p>;
                                break;
                            case "accountUpgrade":
                                notify.name = "PRO";
                                notify.title = "";
                                notify.notify = `account activated successfully`;
                                notify.action = "";
                                break;
                            case "referFriend":
                                notify.name = item.content.data.fullName;
                                notify.title = "";
                                notify.notify = `has submitted your referral code successfully.`;
                                notify.action = "";
                                break;
                            default:
                                break;
                        }
                        let avatar =
                            item.type === "livestreamInvite" ||
                            item.type === "schedule"
                                ? getImage(
                                      item.content.data.livestream
                                          .ownerAttachment
                                  )
                                : item.type === "vipCircle"
                                ? item.content.data.guest.thumbnail
                                : item.content &&
                                  item.content.data &&
                                  getImage(item.content.data.attachment);

                        if (
                            item.type === "livestreamInvite" ||
                            item.type === "schedule"
                        ) {
                            if (
                                item.content &&
                                item.content.data &&
                                item.content.data.livestream &&
                                item.content.data.livestream.ownerAttachment &&
                                item.content.data.livestream.ownerAttachment
                                    .user
                            ) {
                                let isExist = _.find(
                                    users,
                                    (z) =>
                                        z._id ===
                                        item.content.data.livestream
                                            .ownerAttachment.user
                                );
                                if (isExist) {
                                    avatar = getImage(isExist.attachments);
                                }
                            }
                        } else if (item.type === "vipCircle") {
                            if (
                                item.content &&
                                item.content.data &&
                                item.content.data.guest &&
                                item.content.data.guest.userId
                            ) {
                                if (
                                    (item.content.data.status === "Approved" ||
                                        item.content.data.status ===
                                            "Rejected") &&
                                    item.content.data.owner
                                ) {
                                    let isExist = _.find(
                                        users,
                                        (z) =>
                                            z._id === item.content.data.owner.id
                                    );
                                    if (isExist) {
                                        avatar = getImage(isExist.attachments);
                                    }
                                } else {
                                    let isExist = _.find(
                                        users,
                                        (z) =>
                                            z._id ===
                                            item.content.data.guest.userId
                                    );
                                    if (isExist) {
                                        avatar = getImage(isExist.attachments);
                                    }
                                }
                            }
                        } else if (
                            item.content &&
                            item.content.data &&
                            item.content.data.attachment &&
                            item.content.data.attachment.user
                        ) {
                            let isExist = _.find(
                                users,
                                (z) =>
                                    z._id === item.content.data.attachment.user
                            );
                            if (isExist) {
                                avatar = getImage(isExist.attachments);
                            }
                        }

                        return (
                            <div
                                onClick={() => handleClick(item)}
                                key={item._id}
                                className={`flex justify-between items-start border-b border-black-5 p-4 ${
                                    item.isRead ? "" : "bg-[#F5F5F5] my-0"
                                }`}
                            >
                                <div className="flex items-start gap-x-4">
                                    <img
                                        src={avatar}
                                        className="w-10 md:w-12 h-10 md:h-12 rounded-full"
                                        alt=""
                                    />
                                    <div className="">
                                        <h4 className="text-sm md:text-base font-bold text-ebony-color mb-1.5">
                                            {notify.name}
                                        </h4>
                                        <p className="text-sm md:text-sm text-[#707A89]">
                                            {notify.notify}{" "}
                                            <span className="text-purple-color capitalize inline-block ml-1">
                                                {notify.title}
                                            </span>
                                        </p>
                                    </div>
                                </div>

                                <div className="text-right">
                                    <button className="text-orange-color text-sm md:text-sm font-medium mb-1.5 whitespace-nowrap">
                                        {notify.action}
                                    </button>
                                    <p className="text-extraSmall md:text-sm text-[#707A89]">
                                        {moment(item.dateCreated).fromNow()}
                                    </p>
                                </div>
                            </div>
                        );
                    })}
                    {notifications.length === 0 && (
                        <p className="text-center text-lg text-black-50">
                            There is no notification for you.
                        </p>
                    )}
                </div>
            </div>
        </div>
    );
};

export const ReadMoreBtn = () => {
    const dispatch = useDispatch();
    return (
        <button
            onClick={() => dispatch(readAllNotificationRequest())}
            className="text-sm md:text-sm font-medium md:font-bold py-[7px] px-3.5 md:py-2.5 md:px-5  bg-orange-color  text-white rounded-lg"
        >
            Read all
        </button>
    );
};

export default Notification;
